import CristinaImage from "../images/cristina-testimonial.jpg";

const testimonials = [
  {
    id: "cristina-hoyt",
    name: "Cristina Hoyt",
    company: "CristinaHoyt.com",
    image: CristinaImage,
    quote:
      "Since I had my website updated my sales have gone up 300% with an easy to navigate website and integrated SEO. I've started to be able to attract clients I didn't know were available.",
  },
  {
    id: "placeholder-2",
    name: "Happy Client",
    company: "Growing Business",
    image: null,
    quote:
      "Working with Alvarez Branding Co. completely transformed how our customers see us. The new brand feels premium and the website actually converts visitors into paying customers.",
  },
  {
    id: "placeholder-3",
    name: "Satisfied Partner",
    company: "Local Brand",
    image: null,
    quote:
      "They took the time to understand our vision and delivered something that exceeded every expectation. Our online presence finally matches the quality of our work.",
  },
];

export default testimonials;
